<div [appStoryblok]="_editable">
  <div class="container">
    <div class="row">
      <div class="col-md-7" [ngClass]="{ 'order-1': reverse_order }">
        <div class="position-relative h-100">
          <img
            class="w-100 h-auto"
            [height]="height"
            [width]="width"
            [ngSrc]="image.filename"
            *ngIf="image.filename"
            sizes="60vw"
          />
        </div>
      </div>
      <div
        class="col-md-5 d-flex flex-column"
        [ngClass]="[align_y, reverse_order ? 'order-0 mb-4' : 'mt-4']"
      >
        <div
          [style.maxWidth]="
            content_max_width ? content_max_width + 'px' : 'inherit'
          "
        >
          <h1 *ngIf="eyebrow" class="h1 mb-4 display-1">{{ eyebrow }}</h1>
          <div *ngIf="content" class="mb-4" [storyblokRichText]="content"></div>
          <div class="me-2 d-inline-flex" *ngFor="let blok of accordions">
            <ndc-dynamic
              *ngIf="components"
              [ndcDynamicComponent]="components[blok.component]"
              [ndcDynamicInputs]="blok"
            >
            </ndc-dynamic>
          </div>
          <div class="mt-5 pt-4" *ngFor="let blok of actions">
            <ndc-dynamic
              *ngIf="components"
              [ndcDynamicComponent]="components[blok.component]"
              [ndcDynamicInputs]="blok"
            >
            </ndc-dynamic>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
